// Méta-données du cockpit « Encours & Recouvrement ».
import { initials, avatarColor, fmtDate } from '../ops-team/opsMeta';

export { initials, avatarColor, fmtDate };

export const fmtXof = (n) => `${Number(n || 0).toLocaleString('fr-FR')} XOF`;

export const BUCKET_ORDER = ['0-30', '31-60', '61-90', '90+'];

// Ancienneté → couleurs + libellé de risque
export const BUCKET_META = {
  '0-30': {
    label: '0–30 jours', risk: 'Risque faible',
    card: 'border-emerald-200 bg-emerald-50/40',
    icon: 'text-emerald-600', value: 'text-emerald-700',
    riskBadge: 'bg-emerald-100 text-emerald-700', bar: 'bg-emerald-500', ring: '#10b981',
    chip: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  },
  '31-60': {
    label: '31–60 jours', risk: 'Risque modéré',
    card: 'border-yellow-200 bg-yellow-50/40',
    icon: 'text-yellow-600', value: 'text-yellow-700',
    riskBadge: 'bg-yellow-100 text-yellow-700', bar: 'bg-yellow-400', ring: '#eab308',
    chip: 'bg-yellow-50 text-yellow-700 ring-yellow-200',
  },
  '61-90': {
    label: '61–90 jours', risk: 'Risque élevé',
    card: 'border-orange-200 bg-orange-50/40',
    icon: 'text-orange-600', value: 'text-orange-700',
    riskBadge: 'bg-orange-100 text-orange-700', bar: 'bg-orange-500', ring: '#f97316',
    chip: 'bg-orange-50 text-orange-700 ring-orange-200',
  },
  '90+': {
    label: '+90 jours', risk: 'Risque critique',
    card: 'border-red-200 bg-red-50/40',
    icon: 'text-red-600', value: 'text-red-700',
    riskBadge: 'bg-red-100 text-red-700', bar: 'bg-red-500', ring: '#ef4444',
    chip: 'bg-red-50 text-red-700 ring-red-200',
  },
};

// Ancienneté d'une facture (en jours) → clé de bucket
export const bucketOf = (days) => {
  const d = Number(days || 0);
  if (d <= 30) return '0-30';
  if (d <= 60) return '31-60';
  if (d <= 90) return '61-90';
  return '90+';
};

// Mini barre d'ancienneté empilée
export const agingFractions = (bucketTotals = {}) => {
  const sum = BUCKET_ORDER.reduce((a, k) => a + (bucketTotals[k] || 0), 0) || 1;
  return BUCKET_ORDER.map((k) => ({ k, pct: ((bucketTotals[k] || 0) / sum) * 100 }));
};

export const PAYMENT_STATUS_FR = {
  unpaid: 'Impayée', invoiced: 'Impayée', sent: 'Envoyée', partial: 'Partiellement payée',
  partially_paid: 'Partiellement payée',
  paid: 'Payée', overdue: 'En retard', validated: 'Validée', draft: 'Brouillon',
};
